"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UseAbilityActionHandler = exports.UseAbilityActionArgs = void 0;
const Registries_1 = require("../../state/Registries");
const ActionType_1 = require("../ActionType");
class UseAbilityActionArgs {
    constructor(args, requireSlotted = true, ignoreControlMechanics = false) {
        this.args = args;
        this.requireSlotted = requireSlotted;
        this.ignoreControlMechanics = ignoreControlMechanics;
        this.__type = ActionType_1.ActionType.UseAbility;
        this.__typeName = "UseAbility";
    }
}
exports.UseAbilityActionArgs = UseAbilityActionArgs;
let UseAbilityActionHandler = class UseAbilityActionHandler {
    activate(sequence, container, action) {
        if (!(action.args.ignoreControlMechanics || container.canUseAction(action.actorId))) {
            return;
        }
        container.useAbility(sequence, action.actorId, action.args.args, action.args.requireSlotted);
    }
};
UseAbilityActionHandler = __decorate([
    Registries_1.Actions.register(ActionType_1.ActionType.UseAbility)
], UseAbilityActionHandler);
exports.UseAbilityActionHandler = UseAbilityActionHandler;
